import { BookmarkBar } from "../../components/BookmarkBar";
import { TodayEventsCard } from "../../components/cards/TodayEventsCard";
import { MemosCard } from "../../components/cards/MemosCard";
import { MyProjectsCard } from "../../components/cards/MyProjectsCard";
import { TodoBoardCard } from "../../components/cards/TodoBoardCard";

/**
 * ホーム。カードの枠はやめ、見出しの下線と、列の区切り線で区切る(ユーザー要望 2026-10-07)。
 * 最上段にブックマークバー(お知らせはナビゲーションバーのベル。2026-10-14)。その下は 3 列(ユーザー要望 2026-10-14):
 *   左 = Google カレンダー(今日の予定) / 中央 = 参加プロジェクトと ToDo(上下) / 右 = メモ(上から下まで通す)。
 *   承認待ちの候補はホームに出さない(2026-10-07)
 * 広い画面(1024px 以上)は、画面全体をスクロールさせない(AppShell が本文のスクロールを止める)。
 * 列は残りの高さを分け合い、予定の時間軸・ToDo の各列・メモの一覧が、それぞれの中でスクロールする。
 * 狭い画面は 1 列に積み、ページ全体でスクロールする。各区切りは独立して取得・失敗する(SPEC §14.2)。
 */
export function HomePage() {
  return (
    <div className="flex flex-col gap-6 lg:h-full">
      {/* ブックマークバーは、ヘッダーの真下に詰める(本文の余白 p-6 を打ち消す) */}
      <BookmarkBar className="-mx-6 -mt-6" />
      {/* 3 列(1280px 以上): 左: カレンダー / 中央: 参加プロジェクトと ToDo(上下) / 右: メモ。幅は中央 2:メモ 1。
          区切りの縦線は、列の高さいっぱいに通す(各列は伸ばす)。
          1024〜1279px は 2 列にし、メモは中央の列の下段に置く(カレンダーは 2 段ぶち抜き。中央とメモで高さを半分ずつ)。
          1024px 未満は、この並びのまま縦に積む */}
      <div className="grid gap-y-8 lg:min-h-0 lg:flex-1 lg:grid-cols-[26rem_minmax(0,1fr)] lg:grid-rows-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-y-0 xl:grid-cols-[26rem_minmax(0,2fr)_minmax(0,1fr)] xl:grid-rows-[minmax(0,1fr)]">
        <TodayEventsCard className="lg:row-span-2 lg:min-h-0 lg:pr-10 xl:row-span-1" />
        <div className="flex min-w-0 flex-col gap-8 lg:min-h-0 lg:border-l lg:pl-10 xl:pr-10">
          <MyProjectsCard />
          <TodoBoardCard className="lg:min-h-0 lg:flex-1" />
        </div>
        <MemosCard className="lg:min-h-0 lg:border-l lg:pt-8 lg:pl-10 xl:pt-0" />
      </div>
    </div>
  );
}
